import { Box, Flex, Heading } from "@chakra-ui/react";
import ProjectCard from "./ProjectCard";
import {
  FaAngular,
  FaReact,
  FaVuejs,
  FaAndroid,
  FaNodeJs,
  FaLaravel,
  FaWordpress,
  FaJs,
  FaPhp,
  FaAws,
  FaCloudflare,
  FaBitbucket,
  FaGithub,
} from "react-icons/fa";
import { VscAzure } from "react-icons/vsc";

const Projects = (): JSX.Element => {
  const projects = [
    {
      title: "Diva",
      description:
        "Data Intelligence Validation Automation - Turning Raw Data into Trusted Insights Instantly",
      url: "",
      icons: [FaReact, FaGithub, VscAzure],
    },
    {
      title: "Mars",
      description:
        "Mars.ai is an data-AI-insights led marketing resource optimization product.",
      url: "",
      icons: [FaReact, FaGithub, VscAzure],
    },
    {
      title: "Chowkti",
      description: "",
      url: "",
      icons: [
        FaAngular,
        FaAndroid,
        FaLaravel,
        FaNodeJs,
        FaAws,
        FaCloudflare,
        FaBitbucket,
      ],
    },
    {
      title: "Artiner",
      description:
        "Artiner is a platform for all the artist to display, promote and sale their art works to their art lover.",
      url: "",
      icons: [FaVuejs, FaLaravel, FaAws, FaCloudflare, FaBitbucket],
    },
    {
      title: "Axiomway",
      description: "",
      url: "",
      icons: [
        FaAngular,
        FaLaravel,
        FaWordpress,
        FaAws,
        FaCloudflare,
        FaBitbucket,
      ],
    },
    {
      title: "Umbrella",
      description: "One stop employee and ticket management sollution..",
      url: "",
      icons: [FaAngular, FaLaravel, FaAws, FaCloudflare, FaBitbucket],
    },
    {
      title: "Paraffin",
      description: "Paraffin will help you with your personal finance game.",
      url: "",
      icons: [FaAngular, FaLaravel, FaAws, FaCloudflare, FaGithub],
    },
    {
      title: "Repco retail app",
      description: "Repco retail app is progressive web application for Repco.",
      url: "",
      icons: [FaAngular, FaNodeJs, FaAws, FaCloudflare, FaBitbucket],
    },
    {
      title: "Inventory management system",
      description: "",
      url: "",
      icons: [FaVuejs, FaPhp, FaGithub],
    },
    {
      title: "Crawler Monkey",
      description: "A configurable sitemap generator (standalone/library).",
      url: "",
      icons: [FaPhp, FaGithub],
    },
    {
      title: "Ultimate Playground",
      description: "A one stop geming platform for ultimate comfort.",
      url: "",
      icons: [FaJs, FaPhp, FaGithub],
    },
  ];

  return (
    <Box width={"full"} textAlign={"center"}>
      <Heading size={"lg"}>What I've done</Heading>

      <Flex
        marginTop={6}
        justifyContent={"center"}
        wrap={"wrap"}
        alignItems={"stretch"}
        gap={6}
      >
        {projects.map((project: any, index: number) => (
          <ProjectCard
            key={`project-${index}`}
            width={{ base: "100%", md: "33.33%", lg: "calc(25% - 1.5rem)" }}
            project={project}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default Projects;
